import $ from "jquery";
import sanitizeHtml from "sanitize-html";

let data;
let doneSearch;
let geocoder;
let map;
let searchType;
let cityCircle = null;
let selectedRadius = null;
declare let google;
declare let jsrender;
const $loading = $(".js-loading-indicator");
const $findAdviserHeading = $(".js-find-an-adviser-heading");
const $findAdviserItems = $(".js-find-an-adviser-items");

function initDropdown() {
  let selectContainer = document.querySelector(".option-container") as HTMLElement;
  let select = document.querySelector(".select") as HTMLElement;
  let input = document.getElementById("faa-adviser-type") as HTMLInputElement;
  let hiddenInput = document.getElementById("faa-adviser-type-hidden") as HTMLInputElement;
  let options = document.querySelectorAll(".select-container .option");
  let preSelected = document.querySelector(".option.selected") as HTMLElement;

  if (preSelected && input && hiddenInput) {
    input.value = preSelected.dataset["text"];
    hiddenInput.value = preSelected.dataset["value"];
  }

  select.onclick = () => {
    selectContainer.classList.toggle("active");
  };

  options.forEach((e) => {
    e.addEventListener("click", () => {
      let el = e as HTMLElement;
      input.value = el.dataset["text"];
      hiddenInput.value = el.dataset["value"];
      if (doneSearch) {
        addressOrNameSearch();
      }
      selectContainer.classList.remove("active");
      options.forEach((e) => {
        e.classList.remove("selected");
      });
      e.classList.add("selected");
    });
  });
}

function initMap() {
  doneSearch = false;
  geocoder = new google.maps.Geocoder();
  searchType = "location";
  const $findAdviserMap = $(".js-find-an-adviser-map");
  const { lat, lng, zoom } = $findAdviserMap.data();

  map = new google.maps.Map($findAdviserMap[0], {
    center: { lat, lng },
    disableDefaultUI: true,
    zoom,
  });

  showControls(1);
  initDropdown();
  setOverlay(false);

  setTimeout(() => {
    $(".js-find-an-adviser-search-field").focus();
  });
}

function addressOrNameSearch() {
  if (searchType === "name") {
    search();
  } else {
    codeAddress();
  }
}

function codeAddress() {
  // START SPINNER
  $findAdviserItems.html("");
  $loading.show();

  const address = sanitizeHtml($("#address").val()) + ",uk";
  geocoder.geocode({ address }, (results, status) => {
    if (status === "OK") {
      const max = 7.5;
      const min = 10.75;
      const zoomDifference = 1 / (min - max);
      const radius = !selectedRadius ? parseInt($("#faa-radius").val(), 10) : selectedRadius;
      const radiusPercentage = 100 / radius;
      const center = results[0].geometry.location;
      const zoomLevel = radiusPercentage * zoomDifference + max;
      map.setCenter(center);
      map.setZoom(zoomLevel);

      if (cityCircle !== null) {
        cityCircle.setMap(null);
        cityCircle = null;
      }

      cityCircle = new google.maps.Circle({
        center,
        fillColor: "#0f7b3f",
        fillOpacity: 0.35,
        map,
        radius: radius * 1609.34,
        strokeColor: "#0f7b3f",
        strokeOpacity: 0.8,
        strokeWeight: 2,
      });

      search();
    } else {
      resultsError();
      $loading.hide();
    }
  });
}

function search() {
  const adviserApiUrl = $findAdviserItems.data("api-url");
  const sanitizedAddress = sanitizeHtml($("#address").val());
  const sanitizedAdviserType = sanitizeHtml($("#faa-adviser-type-hidden").val());
  let queryString = "";

  if (searchType === "name") {
    queryString = adviserApiUrl + "?name=" + sanitizedAddress + "&adviserType=" + sanitizedAdviserType;
  } else {
    queryString =
      adviserApiUrl +
      "?location=" +
      sanitizedAddress +
      ",uk&radius=" +
      (selectedRadius == null ? $("#faa-radius").val() : selectedRadius) +
      "&adviserType=" +
      sanitizedAdviserType;
  }

  $.get(queryString, (responseData: { Items: any[] }) => {
    responseData.Items = responseData.Items.map((item, index) => {
      item.Id = index;
      return item;
    });

    data = responseData;

    if (data.Items.length === 0) {
      resultsEmpty();
    } else {
      resultsList();
    }

    $loading.hide();
    doneSearch = true;
  }).fail(() => {
    // STOP SPINNER
    $loading.hide();
  });
}

function showControls(id) {
  let controlsData = [{}];

  if (data !== undefined && data.Items !== undefined) {
    controlsData = [
      {
        count: data.Items.length.toString(),
        range: selectedRadius == null ? $("#faa-radius").val() : selectedRadius,
        advType: $("#faa-adviser-type-hidden").val(),
      },
    ];
  }

  const template = jsrender.templates($("#controls" + id).html());
  const resultHtml = template.render(controlsData);

  $(".js-find-an-adviser-controls").html(resultHtml);

  if (id === 1 || id === 5) {
    $findAdviserHeading.show();
  } else {
    $findAdviserHeading.hide();
  }
}

function setDefaultPreselection() {
  let preSelected = document.querySelector(".option.default-option") as HTMLElement;
  let input = document.getElementById("faa-adviser-type") as HTMLInputElement;
  let hiddenInput = document.getElementById("faa-adviser-type-hidden") as HTMLInputElement;
  let options = document.querySelectorAll(".select-container .option");

  if (preSelected && input && hiddenInput) {
    input.value = preSelected.dataset["text"];
    hiddenInput.value = preSelected.dataset["value"];
    options.forEach((e) => {
      e.classList.remove("selected");
    });
    preSelected.classList.add("selected");
  }
}

function resultsList() {
  const template = jsrender.templates($("#resultItem").html());
  const resultHtml = template.render(data.Items);

  $findAdviserItems.html(resultHtml).addClass("find-an-adviser__items-list");

  nameControlsToggle();
}

function resultsError() {
  const template = jsrender.templates($("#resultsError").html());
  const resultHtml = template.render([{}]);

  $findAdviserItems.html(resultHtml);
  nameControlsToggle();
}

function resultsEmpty() {
  const template = jsrender.templates($("#resultsEmpty").html());
  const resultHtml = template.render([{}]);

  $findAdviserItems.html(resultHtml);

  nameControlsToggle();
}

function resetResults() {
  setDefaultPreselection();
  $findAdviserItems.html("");
  removeCircle();
  if (searchType === "name") {
    setOverlay(true);
    showControls(5);
  } else {
    setOverlay(false);
    showControls(1);
  }
  doneSearch = false;
  $("#address").val("");
}

function nameControlsToggle() {
  if (searchType === "name") {
    showControls(4);
  } else {
    showControls(2);
  }
}

function toggleSearch(type) {
  searchType = type;
  resetResults();
}

function removeCircle() {
  if (cityCircle !== null) {
    cityCircle.setMap(null);
    cityCircle = null;
  }
}

function detailsView(id, url) {
  const template = jsrender.templates($("#resultDetails").html());
  const resultHtml = template.render(data.Items[id]);
  window.history.replaceState(null, null, "?adviser=" + url);

  $('input[class^="js-current-url-input-block-"]').each(function () {
    if (this) {
      $(this).val(window.location.href);
    }
  });

  $findAdviserItems.html(resultHtml).removeClass("find-an-adviser__items-list");

  showControls(3);
}

function setOverlay(enable) {
  const $findAdviserOverlay = $("#find-an-adviser__map-overlay");
  if (enable) {
    $findAdviserOverlay.show();
  } else {
    $findAdviserOverlay.hide();
  }
}

function init(): void {
  window["findAnAdviserBootstrap"] = () => {
    initMap();
  };

  window["findAnAdviserSearchClick"] = () => {
    selectedRadius = $("#faa-radius").val();
    addressOrNameSearch();
  };

  window["findAnAdviserDetailsClick"] = (id, url) => {
    detailsView(id, url);
  };

  window["findAnAdviserBackClick"] = () => {
    resultsList();
  };

  window["findAnAdviserToggle"] = (type) => {
    toggleSearch(type);
  };

  window["findAnAdviserResetClick"] = () => {
    resetResults();
  };
}

export default { init };
